<template>
  <section
    role="dialog"
    aria-modal="true"
    aria-labelledby="tour-heading"
    aria-describedby="tour-description"
    class="a-cover lg:flex lg:flex-col header-padding bg-primary overflow-y-auto lg:overflow-hidden"
  >
    <div class="lg:flex lg:h-55% bg-white">
      <div class="lg:flex lg:flex-col lg:h-full lg:w-50%">
        <div class="flex-a p-x h-10 md:h-12 bg-grey-2">
          <BtnBack
            icon="BackIcon"
            aria="Back"
            text="Back"
            iconsize="1.5rem"
            textsize="base"
            iconcolor="primary"
            textcolor="primary"
            class="font-bold"
          />
        </div>
        <h1
          class="flex-a h-8 md:h-12 p-x bg-primary text-white"
          v-html="guidedtour.title"
        />

        <div class="lg:flex-c lg:flex-grow p-x lg:px-5vw">
          <div class="py-4">
            <h2
              id="tour-heading"
              class="border-gold"
              v-html="guidedtour.heading"
            />
            <p id="tour-description" v-html="guidedtour.description" />
          </div>
        </div>
      </div>

      <div class="flex-c h-56 md:h-96 lg:h-full lg:w-50%">
        <Gallery
          :post="guidedtour"
          :allow-rotation="true"
          :titles="false"
          :buttons="false"
          sizing="fit"
        />
      </div>
    </div>

    <div class="p-x pt-6 pb-24 lg:py-0 lg:h-45% lg:px-4vw md:flex-c bg-primary">
      <div class="w-full lg:mb-6">
        <TourStops />

        <Button
          icon="BackIcon"
          iconrotation="rotate-180"
          text="Let's get started"
          :path="path"
          :append="true"
          class="mx-auto mt-6 lg:relative btn-lg btn-white z-1"
          :class="{ 'pin-f-c-b mb-6': mobile }"
        />
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '@/components/buttons/Button.vue'
import BtnBack from '@/components/buttons/BtnBack.vue'
import TourStops from '@/components/TourStops.vue'
import Gallery from '@/components/Gallery.vue'

export default {
  name: 'Tour',

  components: {
    Button,
    BtnBack,
    TourStops,
    Gallery
  },

  computed: {
    ...mapState(['touch', 'mobile', 'phone']),
    ...mapGetters(['guidedtour']),

    path() {
      return this.guidedtour.children[0].slug
    }
  }
}
</script>
